/*global document, FakeCation*/
(function (FC) {
  "use strict";

  function findClickPoints(width, height, pt_left, pt_right, pt_bottom) {
    var center = [(pt_right[0] + pt_left[0]) / 2, (pt_right[1] + pt_left[1]) / 2];

    var d1 = FC.utils.distance(pt_left, pt_right);
    var d2 = FC.utils.distance(center, pt_bottom);

    function bounds(v_c, r, m) {
      var r1 = 0.4 * v_c + 0.4 * r;
      var r2 = 0.4 * (m - v_c) + 0.4 * r;
      return [r1, r2];
    }

    var bx = bounds(center[0], d1, width);
    d1 = Math.min(d1, bx[0]);
    d1 = Math.min(d1, bx[1]);

    var by = bounds(center[1], d2, height);
    d2 = Math.min(d2, by[0]);
    d2 = Math.min(d2, by[1]);

    // calculate the points of upper half ellipse
    var points = (function (c, a, b, n) {
        var pts = [];

        var step = Math.PI / n;

        var theta = Math.PI;

        var x, y;

        while (theta < 2 * Math.PI) {
          x = c[0] + a * Math.cos(theta);
          y = c[1] + b * Math.sin(theta);
          pts.push([x, y]);

          theta += step;
        }

        return pts;
      })(center, d1, d2 * 2, 20)
      .filter(function (p) {
        return p[0] >= 0 && p[0] < width && p[1] >= 0 && p[1] < height;
      });

    return points;
  }

  function getNoseColors(facePoints, imageData) {
    var tx = facePoints[33][0],
      ty = facePoints[33][1],
      bx = facePoints[62][0],
      by = facePoints[62][1],
      t = ty,
      r = Math.max(tx, bx),
      b = by,
      l = Math.min(tx, bx),
      x, y,
      result = [];

    for (x = l; x < r; x++) {
      for (y = t; y < b; y++) {
        result.push(FC.colorUtils.getColor(imageData, x, y));
      }
    }
    return result;
  }

  FC.utils.registerFilter('facetrackWithFlood', function (imgData, cb, config) {
    var canvas = document.createElement('canvas'),
      ctx = canvas.getContext("2d"),
      face;

    canvas.width = imgData.width;
    canvas.height = imgData.height;
    ctx.putImageData(imgData, 0, 0);

    var dumpCtx = FC.utils.dump(imgData);
    console.time('facetrack');
    FC.faceDetect(canvas).then(function (face) {
      console.timeEnd('facetrack');

      dumpCtx.rect(face[0], face[1], face[2], face[3]);
      console.log(face);
      return FC.faceFeatureDetect(canvas, face);
    }).then(function (facePoints) {
      var points = findClickPoints(canvas.width, canvas.height,
          facePoints[1], facePoints[13], facePoints[7]),
        userclickFilter = FC.utils.getFilter('userclick'),
        tracer = FC.utils.getFilter('traceCountours'),
        noseColors = getNoseColors(facePoints, imgData),
        referenceColors = FC.colorUtils.getColors(imgData, points);

      var faceColors = FC.colorUtils.getColors(imgData, facePoints.slice(0, 70));
      var avgFaceColor = FC.colorUtils.Color.average(faceColors);
      var avgReferenceColors = FC.colorUtils.Color.average(referenceColors);
      var hslDiff = {
        h: Math.abs(avgReferenceColors.toHsl()[0] - avgFaceColor.toHsl()[0]) * 0.4,
        s: Math.abs(avgReferenceColors.toHsl()[1] - avgFaceColor.toHsl()[1]) * 0.4,
        l: Math.abs(avgReferenceColors.toHsl()[2] - avgFaceColor.toHsl()[2]) * 0.4
      };

      console.log(avgFaceColor.toHsl(), avgReferenceColors.toHsl());

      userclickFilter(ctx.getImageData(0, 0, canvas.width, canvas.height), function (idata) {
        ctx.putImageData(idata, 0, 0);
        ctx.beginPath();
        ctx.moveTo(facePoints[0][0], facePoints[0][1]);
        facePoints.slice(1, 15).concat(facePoints.slice(-2)).forEach(function (point) {
          ctx.lineTo(point[0], point[1]);
        });
        ctx.closePath();

        ctx.strokeStyle = 'pink';
        ctx.stroke();

        tracer(idata, function (tracedData) {
          cb(tracedData);
        }, {

          cx: facePoints[37][0],
          cy: facePoints[37][1],
          iteration: 100,
          references: referenceColors,
          referencepoints: points,
          stops: faceColors,
          hslDiff: hslDiff,
          rgbDiff: 60
        });
      }, {
        maxDiff: 60,
        points: points
      });
    }).catch(function () {
      config.reject();
    });
  });
}(FakeCation));
